import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

const initialState = { ...getInitialState.list() };

const initAccountForm = {
    displayName: "",
    email: "",
    firstName: "",
    groups: [],
    surname: ""
};

export default function (state = { ...initialState }, action) {
    switch (action.type) {
        case actionTypes.ACCOUNT_ITEM_ADD: {
            return { ...state, item: getInitialState.account() };
        }
        case actionTypes.ACCOUNT_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.ACCOUNT_ITEM_RESET: {
            return { ...state, item: initAccountForm };
        }
        case actionTypes.ACCOUNT_ITEM_SET: {
            const { account } = action.payload;
            return { ...state, item: account };
        }
        case actionTypes.ACCOUNT_ITEM_UPDATE: {
            const { account } = action.payload;
            const { item } = state;
            return { ...state, item: { ...item, ...account } };
        }
        case actionTypes.ACCOUNTS_CLEAR:
        case actionTypes.ACCOUNTS_GET_REQUEST: {
            return { ...initialState };
        }

        case actionTypes.ACCOUNTS_GET_SUCCESS:
        case actionTypes.ACCOUNTS_SET: {
            const { accounts } = action.payload;
            return helpers.getListReducer(state, accounts);
        }
        case actionTypes.ACCOUNTS_MERGE:
        case actionTypes.ACCOUNTS_POST_SUCCESS: {
            const { accounts } = action.payload;
            return helpers.mergeListReducer(state, accounts);
        }
        default: {
            return state;
        }
    }
}
